/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import { IDynamicInputMeta } from 'interfaces/otherInterface/dynamicInput';
import {
  getUserData,
  locateUserAccount,
  requestCashBack,
  saveBankAccountContact,
} from 'queries/ossix/user/userData';
import {
  gatewayAddMoneyFees,
  requestMoneyFromGateway,
  requestSendFundsToGateway,
  requestTransferConfirmation,
  requestVerifyAccount,
} from 'queries/ossix/otherQuery';
import { ossixSupportCountries } from 'queries/ossix/otherQuery';
import gatewayVerifyAccount from 'utils/payloads/gatewayVerifyAccount';
import { CheckboxProps, GetProp, Input, notification } from 'antd';
import Toast from 'components/shared/Alert';
import gatewayTransferConfirmation from 'utils/payloads/gatewayTransferConfirmation';
import {
  GatewayType,
  TargetType,
  TransferSourceType,
} from 'types/generalType';
import { SearchProps } from 'antd/es/input';
import {
  BankTransfer,
  BankTransferConfirmation,
} from './TransfertToBank';
import {
  PayBillsTransferConfirmation,
  TransferPayBillsPayload,
} from './PayBillsPayload';
import {
  MNOTransfer,
  MNOTransferConfirmation,
} from './TransferToMNO';
import {
  CashBackRequest,
  WithdrawCashConfirmation,
} from './WithdrawCashPayload';
import { useNavigate } from 'react-router-dom';
import urls from 'routes/urls';
import {
  OnSaveBeneficiaryParm,
  UseDynamicFormContainerParams,
} from './localInterfaces';
import { useLanguage } from 'hooks/Language/useLanguage';
import { useStatus } from 'hooks/useStatusProvider';
import customerJSONParser from 'helpers/customerJSONParser';
import { useUpdateConfirmModal } from 'hooks/useConfirmModal';
import PendingRequestConfirm from 'components/shared/RequestConfirm/Pending';
import { initialStatus } from 'components/shared/RequestConfirm';

const delay = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

const {
  REACT_APP_ID_NOTIFICATION,
  REACT_APP_API_KEY_NOTIFICATION,
  REACT_APP_LOGIN_NAME_NOTIFICATION,
} = process.env;
const appID = REACT_APP_ID_NOTIFICATION;
const apiKey = REACT_APP_API_KEY_NOTIFICATION;
const loginName = REACT_APP_LOGIN_NAME_NOTIFICATION;

export default ({
  form,
  jsonFields,
  country = null,
  provider,
  accountNumber,
  nextStep,
  handleBackClick,
  accountNumberName,
  accountNumberCurrency,
  printReceipt,
  selectedBeneficiary,
  handleCloseOpenDrawer,
  selectCountry,
}: UseDynamicFormContainerParams) => {
  const { userData } = getUserData();
  const navigate = useNavigate();
  const { status, setStatus } = useStatus();
  const { translate } = useLanguage();
  const { modalStatus, setProps, setUpdateStatus } =
    useUpdateConfirmModal();
  const [openPrintTransaction, setOpenPrintTransaction] =
    useState<boolean>(false);
  const [api, contextHolder] = notification.useNotification();
  const { countries, loadingCountry } = ossixSupportCountries();
  const [fields, setFields] = useState<any>();
  const [inputFormValue, setInputFormValue] = useState<any>();
  const [meta, setMeta] = useState<IDynamicInputMeta | undefined>();
  const [customAmount, setCustomAmount] = useState<string>('');
  const [pin, setPin] = useState<string>('');
  const [formData, setFormData] = useState<any>();
  const [partnerResponse, setPartnerResponse] = useState('');
  const [saveContact, setSaveContact] = useState(false);
  const [fixedInputValue, setFixedInputValue] = useState<string>('');
  const [amount, setAmount] = useState<string>('');
  const [partnerResponseModal, setPartnerResponseModal] =
    useState(false);
  const [openTopConfirm, setOpenTopConfirm] =
    useState<boolean>(false);

  const [showVerificationModal, setShowVerificationModal] =
    useState(false);
  const [verificationData, setVerificationData] = useState<{
    otpRequired: boolean;
    selfieRequired: boolean;
  }>({
    otpRequired: false,
    selfieRequired: false,
  });
  const [verificationPayload, setVerificationPayload] =
    useState<any>(null);

  const {
    verifyAccountData,
    loadVerifyAccount,
    isVerifyAccountError,
    isVerifyAccountSuccess,
    verifyAccountMessage,
    mutate: verifyAccount,
    clearData: requestClearVerifyAccount,
  } = requestVerifyAccount();

  const {
    transferConfirmationData,
    loadTransferConfirmation,
    isTransferConfirmationError,
    isTransferConfirmationSuccess,
    transferConfirmationMessage,
    mutate: transferConfirmation,
    clearData: clearTransferConfirmation,
  } = requestTransferConfirmation();

  const {
    loadCashBack,
    isCashBackError,
    isCashBackSuccess,
    cashBackMessage,
    cashBackData,
    mutate: requestWithdraw,
    clearData: clearCashWithdraw,
  } = requestCashBack();

  const {
    loadSendFundsToGateway,
    isSendFundsToGatewayError,
    isSendFundsToGatewaySuccess,
    sendFundsToGatewayMessage,
    sendFundsToGatewayData,
    mutate: sendFundsToGateway,
    clearData: clearSendFundsToGateway,
  } = requestSendFundsToGateway();

  const {
    locateUserData,
    loadLocateUser,
    isLocateUserError,
    locateUserMessage,
    mutate: requestUserAccount,
    clearData: clearLocatedUserData,
  } = locateUserAccount();

  const {
    loadGatewayAddMoneyFees,
    isGatewayAddMoneyFeesError,
    isGatewayAddMoneyFeesSuccess,
    gatewayAddMoneyFeesMessage,
    gatewayAddMoneyFeesData,
    mutate: requestGatewayAddMoneyFees,
    clearData: clearGatewayAddMoneyFees,
  } = gatewayAddMoneyFees();

  const {
    loadMoneyFromGateway,
    isMoneyFromGatewayError,
    isMoneyFromGatewaySuccess,
    moneyFromGatewayMessage,
    moneyFromGatewayData,
    mutate: moneyFromGateway,
    clearData: clearRequestMoneyFromGateway,
  } = requestMoneyFromGateway();

  const { mutate: requestSaveBankAccountContact } =
    saveBankAccountContact();

  const userSelectedCountry =
    country ||
    userData?.[0]?.OperationCountry ||
    userData?.OperationCountry ||
    userData?.[0]?.CountryCode ||
    userData?.CountryCode ||
    'CM';

  const filterCountry = countries?.filter(
    (item: { CountryCode: string }) =>
      item.CountryCode === userSelectedCountry,
  );

  const onHandleOpenPartnerResponseModal = () =>
    setPartnerResponseModal(true);

  const onHandleClosePartnerResponseModal = () => {
    setPartnerResponseModal(false);
    setPartnerResponse('');
    handleBackClick?.();
    setFixedInputValue('');
  };

  const onChangeFixedInputValue = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { value } = e.target;
    setFixedInputValue(value);
    form?.setFieldsValue({
      Amount: value,
    });
  };

  const handleInputChange = (
    index: number,
    event: { target: { value: any } },
    data: { value: any; checked: any },
  ) => {
    const values = [...fields];
    if (values[index]) {
      const incomingVal =
        data?.value !== undefined
          ? data.value
          : event?.target?.value !== undefined
            ? event.target.value
            : data?.checked;
      values[index] = {
        ...values[index],
        value: incomingVal,
      };
      setFields(values);
    }
    const updatedForm: any = {};
    values.forEach((field: any) => {
      if (field?.type === 'tel') {
        const areaCode =
          filterCountry?.[0]?.PhoneAreaCode ||
          countries?.[0]?.PhoneAreaCode ||
          '237';
        const rawVal = String(field.value ?? '').trim();
        const formattedVal = rawVal.startsWith(areaCode)
          ? rawVal
          : `${areaCode}${rawVal}`;
        updatedForm[field?.key] = rawVal ? formattedVal : '';
        updatedForm['phoneNumber'] = rawVal ? formattedVal : '';
      } else {
        updatedForm[field?.key] = field.value;
      }
    });
    setInputFormValue?.((prev: any) => ({
      ...prev,
      ...updatedForm,
    }));
  };

  function convertStringFieldsToJson(jsonString: any) {
    if (!jsonString) {
      return null;
    }
    if (typeof jsonString === 'object') {
      return jsonString;
    }
    try {
      return JSON.parse(jsonString);
    } catch (error) {
      return null;
    }
  }

  useEffect(() => {
    requestClearVerifyAccount();
  }, [provider]);

  useEffect(() => {
    if (fields) {
      const formatVerifyAccountData =
        fields &&
        fields?.map((item: any) => ({
          [item?.key]: item?.value,
        }));

      const mergedObject = formatVerifyAccountData?.reduce(
        (acc: any, curr: any) => {
          return { ...acc, ...curr };
        },
        {},
      );
      form?.setFieldsValue(mergedObject);
    }
  }, [fields]);

  useEffect(() => {
    const updatedForm: any = {};
    const rawFields =
      jsonFields || provider?.Fields || provider?.FieldsJson;
    const convertedStringFields =
      convertStringFieldsToJson(rawFields);

    if (convertedStringFields?.meta) {
      const data =
        convertedStringFields?.data ||
        convertedStringFields?.fields ||
        [];
      const rawMeta = convertedStringFields?.meta;
      const isVerifyAccount = Boolean(
        rawMeta?.verifyAccount === true ||
          String(rawMeta?.verifyAccount).toLowerCase() === 'true' ||
          String(rawMeta?.verifyAccount).toUpperCase() === 'YES',
      );
      const hasMeta = {
        ...rawMeta,
        verifyAccount: isVerifyAccount,
      };

      updatedForm['inputField'] = hasMeta;
      setMeta(hasMeta);
      setFields(data);
    } else if (convertedStringFields?.data || convertedStringFields?.fields) {
      const fields =
        convertedStringFields?.data || convertedStringFields?.fields;
      setFields(Array.isArray(fields) ? fields : [fields]);
      setMeta(undefined);
    } else if (convertedStringFields) {
      const fields =
        Array.isArray(convertedStringFields)
          ? convertedStringFields
          : [convertedStringFields];
      setFields(fields);
      setMeta(undefined);
    } else {
      setFields([]);
      setMeta(undefined);
    }

    setInputFormValue?.((prev: any) => ({
      ...prev,
      ...updatedForm,
    }));
  }, [jsonFields, provider?.Fields, provider?.FieldsJson]);

  useEffect(() => {
    if (
      verifyAccountData?.Data &&
      verifyAccountData.Data.length > 0
    ) {
      const generateForm = verifyAccountData?.Data.map(
        (item: any) => item,
      );

      const updatedForm: any = {
        inputField: {
          amountType: '',
          verifyAccount: '',
        },
      };

      setFields((prevFields: any) => {
        const newFields = [...prevFields, ...generateForm];
        const isFieldsChanged =
          JSON.stringify(prevFields) !== JSON.stringify(newFields);
        return isFieldsChanged ? newFields : prevFields;
      });

      setInputFormValue?.((prev: any) => ({
        ...prev,
        ...updatedForm,
      }));
    }
  }, [verifyAccountData?.Data]);

  // on form value change
  const onHandleValueChange = (value: any) => {
    setCustomAmount(() => value?.Amount);
    form?.setFieldsValue({
      Amount: value?.amount,
    });
  };

  // Request verify account
  const onHandleVerifyAccount = () => {
    const { inputField, phoneNumber, ...restFormValues } =
      inputFormValue || {};

    const userPID =
      userData?.[0]?.PID ||
      userData?.PID ||
      localStorage.getItem('userPID') ||
      '';

    const countryCode =
      userSelectedCountry ||
      userData?.[0]?.CountryCode ||
      userData?.CountryCode ||
      'CM';

    const accountVal =
      inputFormValue?.serviceNumber ||
      inputFormValue?.accountNumber ||
      phoneNumber ||
      fields?.find(
        (f: any) =>
          f?.key === 'serviceNumber' ||
          f?.key === 'phoneNumber' ||
          f?.key === 'accountNumber',
      )?.value ||
      '';

    const payload = gatewayVerifyAccount({
      PID: userPID,
      CountryCode: countryCode,
      OperatorID: provider?.OperatorID,
      BrandUnikID: provider?.BrandUnikID,
      ShortName: provider?.ShortName,
      ID: provider?.ID,
      OperatorName: provider?.OperatorName,
      Category: provider?.Category,
      TargetType: provider?.TargetType,
      ActionType: provider?.ActionType || '2',
      ServiceRef: provider?.ServiceRef,
      APIKey: apiKey,
      AppID: appID,
      LoginName: loginName,
      VerifyURL: inputField?.verifyURL || '',
      AccountNumber: {
        accountNumber: accountVal,
        ...restFormValues,
        phoneNumber: phoneNumber || accountVal,
      },
    });

    verifyAccount(payload, {
      onError: () => {
        if (isVerifyAccountError) {
          Toast(api, 'Error', verifyAccountMessage);
          clearTransferConfirmation();
        }
      },
    });
  };

  // Save Beneficiaries
  const onSaveBeneficiary = <T,>({
    CountryCode,
    ShortName,
    Category,
    CustomerID,
    AccountNumber,
    FirstName,
    LastName,
    PhoneNumber,
    ActionType,
  }: OnSaveBeneficiaryParm<T>) => {
    const saveRecipientPayload = {
      CountryCode,
      ShortName,
      Category,
      CustomerID,
      AccountNumber,
      FirstName,
      LastName,
      PhoneNumber,
      ActionType,
    };
    requestSaveBankAccountContact(saveRecipientPayload);
  };

  const checkProviderCategory = ({
    providerCategory,
    providerStatus,
  }: {
    providerCategory: string | undefined;
    providerStatus: string | undefined;
  }) => {
    switch (true) {
      case providerCategory === '21':
        return GatewayType.PREPAID_CARD;
      case providerStatus === 'YES':
        return GatewayType.INVOICE_PREPAID;
      default:
        return GatewayType.INVOICE_POSTPAID;
    }
  };
  const [sendVoucher, setSendVoucher] = useState(false);

  const onSendVoucher: CheckboxProps['onChange'] = (e) => {
    setSendVoucher(e.target.checked);
    if (!e.target.checked) {
      clearLocatedUserData();
    }
  };

  // On save contact
  const onHandleSaveContact: CheckboxProps['onChange'] = (e) => {
    setSaveContact(e.target.checked);
  };

  // Bank Transfer Payload
  const onHandleBankGatewayTransferConfirmation = () => {
    const formData = {
      accountName: `${selectedBeneficiary?.FirstName} ${selectedBeneficiary?.LastName}`,
      phoneNumber:
        selectedBeneficiary?.PhoneNumber || userData?.[0]?.MainPhone,
    };

    setAmount(form.getFieldsValue()?.Amount);

    const benefOperator = selectedBeneficiary?.Operator;

    const payload = BankTransferConfirmation({
      onSaveBeneficiary,
      provider: provider ?? selectedBeneficiary,
      inputFormValue: selectedBeneficiary ? formData : inputFormValue,
      accountNumberName,
      description: form.getFieldsValue()?.description || '',
      country:
        (filterCountry && filterCountry[0]?.CountryCode) ||
        userData?.[0]?.CountryCode,
      accountNumber: accountNumber?.value,
      amount:
        customAmount ||
        fixedInputValue ||
        form.getFieldsValue()?.Amount,
      saveContact: saveContact,
      targetAccountNumber:
        selectedBeneficiary?.AccountNumber ||
        selectedBeneficiary?.PhoneNumber,
      targetPhoneNumber:
        selectedBeneficiary?.PhoneNumber || userData?.[0]?.MainPhone,
      userPhoneNumber: userData?.[0]?.MainPhone,
      otherKeys: {
        CountryCode:
          provider?.CountryCode ||
          selectedBeneficiary?.CountryCode ||
          (filterCountry && filterCountry[0]?.CountryCode),
        OperatorID: provider?.OperatorID,
        ID: provider?.ID || benefOperator?.ID,
        ShortName: provider?.ShortName || benefOperator?.ShortName,
        OperatorName:
          provider?.OperatorName || benefOperator?.OperatorName,
        Category: provider?.Category || benefOperator?.ActionType,
        TargetType: provider?.TargetType || benefOperator?.TargetType,
        ActionType: provider?.ActionType || benefOperator?.ActionType,
        ServiceRef: provider?.ServiceRef || benefOperator?.ServiceRef,
        BrandUnikID:
          provider?.BrandUnikID || benefOperator?.BrandUnikID,
        setVerificationData,
        setShowVerificationModal,
        nextStep,
        Toast,
        transferConfirmationMessage,
        clearTransferConfirmation,
        api: api,
      },
    });

    transferConfirmation?.(payload?.transferConfirmation, {
      onSuccess: (data: {
        data: [{ OTPRequired: string; SelfieRequired: string }];
      }) => {
        const transferData = data?.data && data?.data?.[0];
        const otpRequired = transferData?.OTPRequired === 'YES';
        const selfieRequired = transferData?.SelfieRequired === 'YES';

        if (otpRequired || selfieRequired) {
          setVerificationData({
            otpRequired,
            selfieRequired,
          });
          setShowVerificationModal(true);
        } else {
          nextStep?.(2);
        }
      },
      onError: () => {
        Toast(api, 'Error', transferConfirmationMessage);
        clearTransferConfirmation?.();
      },
    });

    if (saveContact) {
      onSaveBeneficiary(payload.saveBenef);
    }

    const dataFrom = form?.getFieldsValue();
    const amount =
      customAmount ||
      fixedInputValue ||
      form.getFieldsValue()?.Amount;

    setFormData((prev: any) => ({
      ...prev,
      ...dataFrom,
      ...{ Amount: amount },
    }));
  };

  //  On Confirm bank transfer
  const onHandleBankConfirmTransfer = () => {
    const formattedFiled = customerJSONParser(provider?.Fields);

    const beneficiary = {
      accountName: `${selectedBeneficiary?.FirstName} ${selectedBeneficiary?.LastName}`,
      phoneNumber:
        selectedBeneficiary?.PhoneNumber || userData?.[0]?.MainPhone,
    };

    const formValues = selectedBeneficiary
      ? { ...formattedFiled?.meta, ...formData, ...beneficiary }
      : {
          ...formattedFiled?.meta,
          ...formData,
        };

    const benefOperator = selectedBeneficiary?.Operator;

    BankTransfer({
      pin,
      inputFormValue,
      sendFundsToGateway,
      provider: provider ?? selectedBeneficiary,
      accountNumber: accountNumber?.value,
      amount: customAmount || fixedInputValue || amount,
      description: form.getFieldsValue()?.description || '',
      destinationCountry:
        selectCountry?.CountryCode ||
        provider?.CountryCode ||
        selectedBeneficiary?.CountryCode ||
        (filterCountry && filterCountry[0]?.CountryCode),
      userPhoneNumber: userData?.[0]?.MainPhone,
      sourceWallet: accountNumber?.value,
      targetAccountNumber:
        selectedBeneficiary?.AccountNumber ||
        selectedBeneficiary?.PhoneNumber,
      targetPhoneNumber:
        selectedBeneficiary?.PhoneNumber || userData?.[0]?.MainPhone,
      targetUrl: formValues?.transferURL,
      formValues: formValues,
      OTP: verificationPayload?.OTP || '',
      SelfieURL: verificationPayload?.SelfieURL || '',
      otherKeys: {
        CountryCode:
          provider?.CountryCode ||
          selectedBeneficiary?.CountryCode ||
          (filterCountry && filterCountry[0]?.CountryCode),
        OperatorID: provider?.OperatorID,
        ID: provider?.ID || benefOperator?.ID,
        ShortName: provider?.ShortName || benefOperator?.ShortName,
        OperatorName:
          provider?.OperatorName || benefOperator?.OperatorName,
        Category: provider?.Category || benefOperator?.ActionType,
        TargetType: provider?.TargetType || benefOperator?.TargetType,
        ActionType: provider?.ActionType || benefOperator?.ActionType,
        ServiceRef: provider?.ServiceRef || benefOperator?.ServiceRef,
        BrandUnikID:
          provider?.BrandUnikID || benefOperator?.BrandUnikID,
      },
    });
  };

  // On Confirm MNO transfer confirmation
  const onHandleMNOTransferConfirmation = () => {
    const amount =
      customAmount ||
      fixedInputValue ||
      form.getFieldsValue()?.Amount;

    const payload = MNOTransferConfirmation({
      provider: provider ?? selectedBeneficiary,
      inputFormValue,
      accountNumberName,
      description: form.getFieldsValue()?.description || '',
      country: filterCountry && filterCountry[0]?.CountryCode,
      accountNumber: accountNumber?.value,
      amount: amount,
      userPhoneNumber: userData?.[0]?.MainPhone,
      targetAccountNumber:
        selectedBeneficiary?.AccountNumber ||
        selectedBeneficiary?.PhoneNumber,
      targetPhoneNumber:
        selectedBeneficiary?.PhoneNumber || userData?.[0]?.MainPhone,
      otherKeys: {
        CountryCode:
          provider?.CountryCode ||
          selectedBeneficiary?.CountryCode ||
          (filterCountry && filterCountry[0]?.CountryCode),
        OperatorID: provider?.OperatorID,
        ID: provider?.ID,
        ShortName: provider?.ShortName,
        OperatorName: provider?.OperatorName,
        Category: provider?.Category,
        TargetType: provider?.TargetType,
        ActionType: provider?.ActionType,
        ServiceRef: provider?.ServiceRef,
        BrandUnikID: provider?.BrandUnikID,
      },
      formValues: { ...formData },
    });

    transferConfirmation(payload.transferConfirmationPayload, {
      onSuccess: () => {
        if (saveContact) {
          onSaveBeneficiary(payload.saveBeneficiaryPayload);
        }

        nextStep?.(2);
        return;
      },
      onError: (error) => {
        Toast(
          api,
          'Error',
          error?.response?.data?.[0]?.Description ||
            transferConfirmationMessage,
        );
        clearTransferConfirmation();
      },
    });

    const dataFrom = form?.getFieldsValue();
    setFormData((prev: any) => ({
      ...prev,
      ...dataFrom,
      ...{ Amount: amount },
    }));

    return;
  };

  //  On Confirm MNO transfer
  const onHandleMNOConfirmTransfer = () => {
    const providerData = provider || selectedBeneficiary;

    const formattedFiled = customerJSONParser(provider?.Fields);

    const formValues = {
      ...formattedFiled?.meta,
      ...formData,
    };

    const amount =
      customAmount ||
      fixedInputValue ||
      form.getFieldsValue()?.Amount ||
      formValues?.Amount;

    MNOTransfer({
      pin,
      inputFormValue,
      provider: providerData,
      sendFundsToGateway,
      amount: amount,
      accountNumber: accountNumber?.value,
      country: filterCountry && filterCountry[0]?.CountryCode,
      description: form.getFieldsValue()?.description || '',
      destinationCountry:
        selectCountry?.CountryCode ||
        providerData?.CountryCode ||
        selectedBeneficiary?.CountryCode ||
        (filterCountry && filterCountry[0]?.CountryCode),
      userPhoneNumber: userData?.[0]?.MainPhone,
      sourceWallet: accountNumber?.value,
      targetAccountNumber:
        selectedBeneficiary?.AccountNumber ||
        selectedBeneficiary?.PhoneNumber,
      targetPhoneNumber:
        selectedBeneficiary?.PhoneNumber || userData?.[0]?.MainPhone,
      targetUrl: formValues?.transferURL,
      formValues: formValues,
      otherKeys: {
        CountryCode:
          providerData?.CountryCode ||
          selectedBeneficiary?.CountryCode ||
          (filterCountry && filterCountry[0]?.CountryCode),
        OperatorID: providerData?.OperatorID,
        ID: providerData?.ID,
        ShortName: providerData?.ShortName,
        OperatorName: providerData?.OperatorName,
        Category: providerData?.Category,
        TargetType: providerData?.TargetType,
        ActionType: providerData?.ActionType,
        ServiceRef: providerData?.ServiceRef,
        BrandUnikID: providerData?.BrandUnikID,
      },
    });

    return;
  };

  // On PayBills transfer confirmation
  const onHandleGatewayTransferConfirmation = () => {
    const payload = PayBillsTransferConfirmation({
      inputFormValue,
      provider,
      // onSaveBeneficiary,
      accountNumber: accountNumber?.value,
      ContactPID: locateUserData?.PID || '',
      description: form.getFieldsValue()?.description || '',
      country: filterCountry && filterCountry[0]?.CountryCode,
      gatewayTransferConfirmation,
      // transferConfirmation,
      GatewayOperationType:
        checkProviderCategory({
          providerCategory: provider?.Category,
          providerStatus: provider?.PrePaid,
        }) || '',
      amount: customAmount || fixedInputValue,
      // saveContact: saveContact,
      defaultPhoneNumber: userData?.[0]?.MainPhone,
      otherKeys: {
        CountryCode:
          provider?.CountryCode ||
          selectedBeneficiary?.CountryCode ||
          (filterCountry && filterCountry[0]?.CountryCode),
        OperatorID: provider?.OperatorID,
        ID: provider?.ID,
        ShortName: provider?.ShortName,
        OperatorName: provider?.OperatorName,
        Category: provider?.Category,
        TargetType: provider?.TargetType,
        ActionType: provider?.ActionType,
        ServiceRef: provider?.ServiceRef,
        BrandUnikID: provider?.BrandUnikID,
      },
    });

    transferConfirmation(payload.transferConfirmation, {
      onSuccess: () => {
        if (saveContact) {
          onSaveBeneficiary(payload.saveBenef);
        }
        nextStep?.(2);
      },
      onError: (error) => {
        Toast(
          api,
          'Error',
          error?.response?.data?.[0]?.Description ||
            transferConfirmationMessage,
        );
      },
    });

    const dataFrom = form?.getFieldsValue();
    const amount =
      customAmount ||
      fixedInputValue ||
      form?.getFieldsValue()?.Amount;

    setFormData((prev: any) => ({
      ...prev,
      ...dataFrom,
      ...{ Amount: amount },
    }));
  };

  //   On PIN input value change
  const onPINValuesChange: GetProp<typeof Input.OTP, 'onChange'> = (
    value: any,
  ) => setPin(value);

  //  On Locate User Account
  const onSearch: SearchProps['onSearch'] = (value) =>
    requestUserAccount({
      WalletNumber: value,
    });

  // On submit transfer
  const onHandleConfirmTransfer = () => {
    // const payload = TransferPayBillsPayload({
    TransferPayBillsPayload({
      FirstName: locateUserData?.FirstName || '',
      LastName: locateUserData?.LastName || '',
      defaultPhoneNumber: userData?.[0]?.MainPhone,
      inputFormValue,
      ContactPID: locateUserData?.PID || '',
      description: form.getFieldsValue()?.description || '',
      country:
        (filterCountry && filterCountry[0]?.CountryCode) ||
        userData?.[0]?.CountryCode,
      amount: customAmount || fixedInputValue,
      accountNumber: accountNumber?.value,
      sendFundsToGateway,
      pin,
      GatewayOperationType: checkProviderCategory({
        providerCategory: provider?.Category,
        providerStatus: provider?.PrePaid,
      }),
      provider,
      formValues: formData,
      OTP: verificationPayload?.OTP || '',
      SelfieURL: verificationPayload?.SelfieURL || '',
      otherKeys: {
        CountryCode:
          provider?.CountryCode ||
          selectedBeneficiary?.CountryCode ||
          (filterCountry && filterCountry[0]?.CountryCode),
        OperatorID: provider?.OperatorID,
        ID: provider?.ID,
        ShortName: provider?.ShortName,
        OperatorName: provider?.OperatorName,
        Category: provider?.Category,
        TargetType: provider?.TargetType,
        ActionType: provider?.ActionType,
        ServiceRef: provider?.ServiceRef,
        BrandUnikID: provider?.BrandUnikID,
      },
    });

    // sendFundsToGateway(payload, {
    //   onSuccess: () => {
    //     // Handle success
    //   },
    //   onError: (error) => {
    //     // Handle error
    //   },
    // });
  };

  //On submit cash withdraw transfer confirmation
  const onHandleCashWithdrawTransferConfirmation = () => {
    const formData = form?.getFieldsValue();
    setCustomAmount(formData?.amount);
    WithdrawCashConfirmation({
      Amount: formData?.amount,
      CountryCode:
        (filterCountry && filterCountry[0]?.CountryCode) ||
        userData?.[0]?.CountryCode,
      GatewayOperationType: GatewayType.BANK_TRANSFER,
      SourceWallet: accountNumber?.value,
      TargetCurrency: accountNumberCurrency,
      TargetCountryCode:
        selectCountry?.CountryCode ||
        (filterCountry && filterCountry[0]?.CountryCode),
      TargetType: TargetType.CashOut,
      transferConfirmation,
      otherKeys: {
        CountryCode:
          provider?.CountryCode ||
          selectedBeneficiary?.CountryCode ||
          (filterCountry && filterCountry[0]?.CountryCode),
        OperatorID: provider?.OperatorID,
        ID: provider?.ID,
        ShortName: provider?.ShortName,
        OperatorName: provider?.OperatorName,
        Category: provider?.Category,
        TargetType: provider?.TargetType,
        ActionType: provider?.ActionType,
        ServiceRef: provider?.ServiceRef,
        BrandUnikID: provider?.BrandUnikID,
      },
    });
  };

  // On Top Money Gateway Add Money Fees

  const onHandleGatewayAddMoneyFees = () => {
    requestGatewayAddMoneyFees(
      {
        PID: userData && userData[0]?.PID,
        Gateway: TransferSourceType.MOBILE,
        Amount: customAmount || fixedInputValue,
        Currency: userData[0]?.MainCurrency,
        CountryCode: userData[0]?.CountryCode,
      },
      {
        onSuccess: () => {
          setOpenTopConfirm(true);
        },
        onError: (error) => {
          Toast(
            api,
            'Error',
            error?.response?.data?.[0]?.Description ||
              cashBackMessage,
          );
          clearCashWithdraw();
        },
      },
    );
  };

  // On money From Gateway
  const handleMoneyFromGateway = (pin: string) => {
    const {
      inputField,
      phoneNumber,
      firstName,
      lastName,
      ...restFormValues
    } = inputFormValue;

    const { serviceNumber, ...restFormData } = form.getFieldsValue();

    moneyFromGateway({
      CountryCode: userSelectedCountry,
      OperatorID: provider?.OperatorID,
      BrandUnikID: provider?.BrandUnikID,
      ShortName: provider?.ShortName,
      ID: provider?.ID,
      OperatorName: provider?.OperatorName,
      Category: provider?.Category,
      TargetType: provider?.TargetType,
      ActionType: provider?.ActionType,
      ServiceRef: provider?.ServiceRef,
      PIN: pin,
      Amount: customAmount || fixedInputValue,
      Currency: userData[0]?.MainCurrency,
      Wallet: accountNumber?.value,
      SourceType: TransferSourceType.BANK,
      PhoneNumber: phoneNumber || userData?.[0]?.MainPhone,
      serviceNumber: phoneNumber || userData?.[0]?.MainPhone,
      name: restFormData?.name,
      accountStatus: restFormData?.accountStatus,
      TargetAccountNumber:
        restFormValues?.serviceNumber ||
        restFormValues?.referenceNumber ||
        restFormValues?.phoneNumber,
      PartnerRequest: {
        merchant: provider?.ShortName || provider?.OperatorName,
        phoneNumber:
          restFormValues?.serviceNumber ||
          phoneNumber ||
          userData?.[0]?.MainPhone,
        accountNumber: restFormValues?.serviceNumber || phoneNumber,
        ...restFormData,
        ...restFormValues,
      },
    });
  };

  const onHandleCashBackRequest = () => {
    CashBackRequest({
      Amount: customAmount,
      PIN: pin,
      SourceWallet: accountNumber?.value,
      TargetWallet: '',
      DestCountryCode:
        (filterCountry && filterCountry[0]?.CountryCode) ||
        userData?.[0]?.CountryCode,
      requestCashBack: requestWithdraw,
      otherKeys: {
        CountryCode:
          provider?.CountryCode ||
          selectedBeneficiary?.CountryCode ||
          (filterCountry && filterCountry[0]?.CountryCode),
        OperatorID: provider?.OperatorID,
        ID: provider?.ID,
        ShortName: provider?.ShortName,
        OperatorName: provider?.OperatorName,
        Category: provider?.Category,
        TargetType: provider?.TargetType,
        ActionType: provider?.ActionType,
        ServiceRef: provider?.ServiceRef,
        BrandUnikID: provider?.BrandUnikID,
      },
    });
  };

  const performActionWithDelay = async () => {
    await delay(1000);
    navigate(urls.transactions);
  };

  const onHandleUpdateStatus = () => {
    setStatus((prevStatus) => ({
      ...prevStatus,
      isCanceled: false,
      isPending: true,
      isSuccess: false,
    }));
  };

  const onHandleClosePrintPage = () => {
    nextStep?.(1);
    setCustomAmount('');
    setInputFormValue({});
    onHandleOpenPartnerResponseModal();
    clearSendFundsToGateway();
    clearLocatedUserData();
    clearTransferConfirmation();
    requestClearVerifyAccount();
    setFixedInputValue('');
    form?.resetFields();
    setFormData({});
    performActionWithDelay();
    setOpenPrintTransaction(false);
    performActionWithDelay();
  };

  const handleCloseTopConfirm = () => {
    setOpenTopConfirm(false);
    clearGatewayAddMoneyFees();
  };

  const handleVerificationComplete = (data: {
    otp?: string;
    selfieUrl?: string;
  }) => {
    setVerificationPayload({
      OTP: data.otp || '',
      SelfieURL: data.selfieUrl || '',
    });

    setShowVerificationModal(false);

    nextStep?.(2);

    Toast(api, 'Success', 'Verification completed successfully');
  };

  const handleVerificationCancel = () => {
    setShowVerificationModal(false);
    setVerificationData({
      otpRequired: false,
      selfieRequired: false,
    });
    Toast(api, 'Info', 'Verification cancelled');
  };

  useEffect(() => {
    if (isSendFundsToGatewaySuccess && !isMoneyFromGatewaySuccess) {
      if (
        sendFundsToGatewayData?.FeedBackRequired === 'YES' &&
        !printReceipt
      ) {
        onHandleUpdateStatus();
      } else if (
        sendFundsToGatewayData?.FeedBackRequired === 'YES' &&
        printReceipt
      ) {
        setOpenPrintTransaction(true);
      } else {
        if (!printReceipt) {
          Toast(api, 'Success', sendFundsToGatewayMessage);
        }
      }
    }

    if (isCashBackSuccess) {
      Toast(api, 'Success', cashBackMessage);
      nextStep?.(1);
      onHandleOpenPartnerResponseModal();
      clearSendFundsToGateway();
      clearTransferConfirmation();
      form?.resetFields();
      clearCashWithdraw();
    }

    if (isLocateUserError) {
      Toast(api, 'Error', locateUserMessage);
    }

    if (isSendFundsToGatewayError) {
      Toast(api, 'Error', sendFundsToGatewayMessage);
      clearSendFundsToGateway();
    }

    if (isCashBackError) {
      Toast(api, 'Error', gatewayAddMoneyFeesMessage);
      clearGatewayAddMoneyFees();
    }

    if (isMoneyFromGatewaySuccess && !isSendFundsToGatewaySuccess) {
      onHandleUpdateStatus();
      form?.resetFields();
      setInputFormValue({});
    }

    if (isMoneyFromGatewayError) {
      Toast(api, 'Error', moneyFromGatewayMessage);
      clearRequestMoneyFromGateway();
    }

    if (sendFundsToGatewayData?.FeedBackRequired === 'YES') {
      const getPartResponse = convertStringToArray(
        sendFundsToGatewayData?.PartnerResponse,
      );

      setPartnerResponse({
        ...sendFundsToGatewayData,
        ...getPartResponse,
      });
    }

    if (cashBackData) {
      setPartnerResponse({
        ...cashBackData,
      });
    }
  }, [
    api,
    isVerifyAccountError,
    verifyAccountMessage,
    // isTransferConfirmationError,
    // transferConfirmationMessage,
    // isTransferConfirmationSuccess,
    isSendFundsToGatewayError,
    isSendFundsToGatewaySuccess,
    sendFundsToGatewayMessage,
    sendFundsToGatewayData,
    isLocateUserError,
    locateUserMessage,
    isCashBackError,
    isCashBackSuccess,
    cashBackMessage,
    isGatewayAddMoneyFeesError,
    isGatewayAddMoneyFeesSuccess,
    gatewayAddMoneyFeesMessage,
    isMoneyFromGatewaySuccess,
    isMoneyFromGatewayError,
    moneyFromGatewayMessage,
  ]);

  useEffect(() => {
    if (status.isPending) {
      setProps({
        icon: <PendingRequestConfirm />,
        translate: translate,
        title: translate('Pending'),
        subtitle: translate(
          moneyFromGatewayMessage || sendFundsToGatewayMessage,
        ),
        modalStatus: modalStatus,
        status: { isPending: true },
        onClick: () => {
          handleCloseOpenDrawer?.();
          clearRequestMoneyFromGateway();
          setStatus((prevStatus) => ({
            ...prevStatus,
            isCanceled: false,
            isPending: false,
            isSuccess: false,
          }));
        },
        transactionDetails: {
          TransactionID:
            sendFundsToGatewayData?.TransactionID ||
            moneyFromGatewayData?.TransactionID ||
            '',
          Amount:
            sendFundsToGatewayData?.Amount ||
            moneyFromGatewayData?.Amount ||
            '',
          Fees: sendFundsToGatewayData?.Fees || '',
          ExchangeFees: sendFundsToGatewayData?.ExchangeFees || '',
          Taxes: sendFundsToGatewayData?.Taxes || '',
          TotalAmount: sendFundsToGatewayData?.TotalAmount || '',
          ExchangeRate: sendFundsToGatewayData?.ExchangeRate,
        },
      });

      setUpdateStatus((prev: any) => ({
        ...prev,
        isCanceled: false,
        isPending: true,
        isSuccess: false,
        closePending: false,
        onCloseDrawer: handleCloseOpenDrawer,
      }));
      localStorage.setItem('currentAlert', 'pending');
    }
  }, [status, navigate]);

  useEffect(() => {
    if (modalStatus.isPending) {
      handleCloseOpenDrawer?.();
      clearRequestMoneyFromGateway();
    }

    if (modalStatus.isCanceled) {
      handleCloseOpenDrawer?.();
      setUpdateStatus(initialStatus);
    }

    if (modalStatus.isSuccess) {
      handleCloseOpenDrawer?.();
      setUpdateStatus(initialStatus);
    }
  }, [modalStatus.isCanceled, modalStatus.isPending]);

  return {
    api,
    fields,
    meta,
    setMeta,
    handleInputChange,
    fixedInputValue,
    onChangeFixedInputValue,
    onHandleVerifyAccount,
    loadVerifyAccount,
    isVerifyAccountError,
    isVerifyAccountSuccess,
    verifyAccountMessage,
    filterCountry,
    loadingCountry,
    contextHolder,
    onHandleTransferConfirmation: onHandleGatewayTransferConfirmation,
    onHandleValueChange,
    transferConfirmationData: transferConfirmationData,
    loadTransferConfirmation,
    isTransferConfirmationSuccess,
    onPINValuesChange,
    onHandleConfirmTransfer,
    loadSendFundsToGateway,
    userData,
    clearForm: setFields,
    onHandleClosePartnerResponseModal,
    openPartnerResponseModal: partnerResponseModal,
    partnerResponseData: partnerResponse,
    provider,
    setFixedInputValue,
    formData,
    setFormData,
    sendVoucher,
    onSendVoucher,
    setSendVoucher,
    onSearch,
    loadLocateUser,
    clearLocatedUserData,
    locateUserData,
    clearSendFundsToGateway,
    clearTransferConfirmation,
    onHandleBankGatewayTransferConfirmation,
    onHandleBankConfirmTransfer,
    onHandleSaveContact,
    onHandleMNOTransferConfirmation,
    onHandleMNOConfirmTransfer,
    onHandleCashWithdrawTransferConfirmation,
    onHandleCashBackRequest,
    loadCashBack,
    clearCashWithdraw: clearCashWithdraw,
    userSelectedCountry,
    inputFormValue,
    verifyAccount,
    verifyAccountData: verifyAccountData,
    openPrintTransaction,
    sendFundsToGatewayData,
    onHandleClosePrintPage,
    onHandleGatewayAddMoneyFees,
    loadGatewayAddMoneyFees,
    openTopConfirm,
    handleCloseTopConfirm,
    gatewayAddMoneyFeesMessage,
    handleMoneyFromGateway,
    loadMoneyFromGateway,
    isMoneyFromGatewaySuccess,
    gatewayAddMoneyFeesData,
    // Verification

    showVerificationModal,
    verificationData,
    handleVerificationComplete,
    handleVerificationCancel,
    verificationPayload,
  };
};

const convertStringToArray = (text: string) => {
  const generalFieldsFromString = text !== '' ? text : '[]';
  const result = JSON.parse(generalFieldsFromString);
  return result;
};
